import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useSpeechToText } from '../hooks/useSpeechToText';
import { resolveAllowedSections, sectionForPath } from '../constants/planSections';

const useGetPlanSections = () => {
    return useSelector(
      (state) => state?.AuthReducer?.userLogindata?.data?.plan?.sections,
      shallowEqual
    );
  };

const useGetUserPermissions = () => {
    return useSelector(
      (state) => state?.AuthReducer?.userLogindata?.data?.permissions,
      shallowEqual
    );
  };

const useAllowedSections = () => {
    const role = useSelector((state) => state?.AuthReducer?.userLogindata?.data?.role);
    const planSections = useGetPlanSections();
    const permissions = useGetUserPermissions();

    return useMemo(
      () => resolveAllowedSections({ role, planSections, permissions }),
      [role, planSections, permissions]
    );
  };

const useCanAccessPath = (pathname) => {
    const allowedSections = useAllowedSections();
    const section = sectionForPath(pathname);
    return !section || allowedSections.includes(section);
  };

export {
  useGetPlanSections,
  useGetUserPermissions,
  useAllowedSections,
  useCanAccessPath,
  useSpeechToText,
};
